import graphql from './graphql';

const mapEmployee = (data, t) => {
  if (!data?.User_list) return [];

  return data.User_list.map(user => [
    user.payrollNum,
    user.fullName,
    user.Department.name,
    user.JobTitle.name,
    user.Role.name,
    user.Terminal.name,
    user.status ? t('Generic.Active') : t('Generic.Inactive'), // as Text
    user.entryDate,
    user.status, // as Boolean
    user.id,
    false,
  ]);
};

const mapTerminal = data => {
  if (!data?.Terminal_list) return [];
  return data.Terminal_list.map(terminal => terminal.name);
};

const mapDepartment = data => {
  if (!data?.Department_list) return [];
  return data.Department_list.map(department => department.name);
};

const mapRole = data => {
  if (!data?.Role_list) return [];
  return data.Role_list.map(role => [role.name, role.id]);
};

const fetch = async t => {
  const promises = [];
  promises.push(
    graphql(
      'User_list',
      'id payrollNum fullName status Terminal{ name } JobTitle{ name } Department{ name } Role { name }, entryDate',
      'query'
    ).catch(() => [])
  );
  promises.push(graphql('Department_list', 'name', 'query').catch(() => []));
  promises.push(graphql('Terminal_list', 'name', 'query').catch(() => []));
  promises.push(graphql('Role_list', 'name id', 'query').catch(() => []));

  const data = await Promise.all(promises);
  const employees = mapEmployee(data[0], t);
  const department = mapDepartment(data[1]);
  const terminal = mapTerminal(data[2]);
  const role = mapRole(data[3]);

  return { employees, terminal, department, role };
};

export default fetch;
